import { render } from "./AttributeText.vue?vue&type=template&id=f67c7d16&scoped=true"
import script from "./AttributeText.vue?vue&type=script&lang=js"
export * from "./AttributeText.vue?vue&type=script&lang=js"

import "./AttributeText.vue?vue&type=style&index=0&id=f67c7d16&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f67c7d16"]])

export default __exports__